export default {
    'zh_CN': {
        'system.dict-data.id.label': '字典编码',
        'system.dict-data.id.holder': '请输入字典编码',


        'system.dict-data.id.required': '字典编码必填',
        'system.dict-data.dictSign.label': '字典类型',
        'system.dict-data.dictSign.holder': '请输入字典类型',
        'system.dict-data.dictSign.max': '字典类型最多100个字符',

        'system.dict-data.dictSign.required': '字典类型必填',
        'system.dict-data.dictValue.label': '字典标签',
        'system.dict-data.dictValue.holder': '请输入字典标签',
        'system.dict-data.dictValue.max': '字典标签最多100个字符',

        'system.dict-data.dictValue.required': '字典标签必填',
        'system.dict-data.dictKey.label': '字典键值',
        'system.dict-data.dictKey.holder': '请输入字典键值',
        'system.dict-data.dictKey.max': '字典键值最多100个字符',

        'system.dict-data.dictKey.required': '字典键值必填',
        'system.dict-data.styleClass.label': '表格回显样式',
        'system.dict-data.styleClass.holder': '请输入表格回显样式',
        'system.dict-data.styleClass.max': '表格回显样式最多100个字符',

        'system.dict-data.styleClass.required': '表格回显样式必填',
        'system.dict-data.isDefault.label': '是否默认',
        'system.dict-data.isDefault.holder': '请输入是否默认',


        'system.dict-data.isDefault.dictionary': ()=>[{value:0,label:'否'},{value:1,label:'是'}],
        'system.dict-data.isDefault.required': '是否默认必填',
        'system.dict-data.dictSort.label': '字典排序',
        'system.dict-data.dictSort.holder': '请输入字典排序',


        'system.dict-data.dictSort.required': '字典排序必填',
        'system.dict-data.status.label': '状态',
        'system.dict-data.status.holder': '请输入状态',


        'system.dict-data.status.dictionary': ()=>[{value:0,label:'禁用'},{value:1,label:'启用'}],
        'system.dict-data.status.required': '状态必填',
        'system.dict-data.remark.label': '备注',
        'system.dict-data.remark.holder': '请输入备注',
        'system.dict-data.remark.max': '备注最多500个字符',

        'system.dict-data.remark.required': '备注必填',
        'system.dict-data.createTime.label': '创建时间',
        'system.dict-data.createTime.holder': '请输入创建时间',
        'system.dict-data.createTime.required': '创建时间必填',
        'system.dict-data.updateTime.label': '更新时间',
        'system.dict-data.updateTime.holder': '请输入更新时间',
        'system.dict-data.updateTime.required': '更新时间必填',
        'system.dict-data.deleted.label': '是否删除',
        'system.dict-data.deleted.holder': '请输入是否删除',
        'system.dict-data.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'system.dict-data.id.label': '字典编码',
        'system.dict-data.id.holder': '請輸入字典编码',


        'system.dict-data.id.required': '字典编码必填',
        'system.dict-data.dictSign.label': '字典类型',
        'system.dict-data.dictSign.holder': '請輸入字典类型',


        'system.dict-data.dictSign.required': '字典类型必填',
        'system.dict-data.dictValue.label': '字典标签',
        'system.dict-data.dictValue.holder': '請輸入字典标签',


        'system.dict-data.dictValue.required': '字典标签必填',
        'system.dict-data.dictKey.label': '字典键值',
        'system.dict-data.dictKey.holder': '請輸入字典键值',


        'system.dict-data.dictKey.required': '字典键值必填',
        'system.dict-data.styleClass.label': '表格回显样式',
        'system.dict-data.styleClass.holder': '請輸入表格回显样式',


        'system.dict-data.styleClass.required': '表格回显样式必填',
        'system.dict-data.isDefault.label': '是否默认',
        'system.dict-data.isDefault.holder': '請輸入是否默认',


        'system.dict-data.isDefault.required': '是否默认必填',
        'system.dict-data.dictSort.label': '字典排序',
        'system.dict-data.dictSort.holder': '請輸入字典排序',


        'system.dict-data.dictSort.required': '字典排序必填',
        'system.dict-data.status.label': '状态',
        'system.dict-data.status.holder': '請輸入状态',


        'system.dict-data.status.required': '状态必填',
        'system.dict-data.remark.label': '备注',
        'system.dict-data.remark.holder': '請輸入备注',


        'system.dict-data.remark.required': '备注必填',
        'system.dict-data.createTime.label': '创建时间',
        'system.dict-data.createTime.holder': '請輸入创建时间',


        'system.dict-data.createTime.required': '创建时间必填',
        'system.dict-data.updateTime.label': '更新时间',
        'system.dict-data.updateTime.holder': '請輸入更新时间',


        'system.dict-data.updateTime.required': '更新时间必填',
        'system.dict-data.deleted.label': '是否删除',
        'system.dict-data.deleted.holder': '請輸入是否删除',


        'system.dict-data.deleted.required': '是否删除必填'
    },
    'en_US': {
        'system.dict-data.id.label': 'id',
        'system.dict-data.id.holder': 'Enter id',
        'system.dict-data.id.max': 'id max length: 字典编码',


        'system.dict-data.id.required': 'id required',
        'system.dict-data.dictSign.label': 'dictSign',
        'system.dict-data.dictSign.holder': 'Enter dictSign',
        'system.dict-data.dictSign.max': 'dictSign max length: 字典类型',


        'system.dict-data.dictSign.required': 'dictSign required',
        'system.dict-data.dictValue.label': 'dictValue',
        'system.dict-data.dictValue.holder': 'Enter dictValue',
        'system.dict-data.dictValue.max': 'dictValue max length: 字典标签',


        'system.dict-data.dictValue.required': 'dictValue required',
        'system.dict-data.dictKey.label': 'dictKey',
        'system.dict-data.dictKey.holder': 'Enter dictKey',
        'system.dict-data.dictKey.max': 'dictKey max length: 字典键值',


        'system.dict-data.dictKey.required': 'dictKey required',
        'system.dict-data.styleClass.label': 'styleClass',
        'system.dict-data.styleClass.holder': 'Enter styleClass',
        'system.dict-data.styleClass.max': 'styleClass max length: 表格回显样式',


        'system.dict-data.styleClass.required': 'styleClass required',
        'system.dict-data.isDefault.label': 'isDefault',
        'system.dict-data.isDefault.holder': 'Enter isDefault',
        'system.dict-data.isDefault.max': 'isDefault max length: 是否默认',


        'system.dict-data.isDefault.required': 'isDefault required',
        'system.dict-data.dictSort.label': 'dictSort',
        'system.dict-data.dictSort.holder': 'Enter dictSort',
        'system.dict-data.dictSort.max': 'dictSort max length: 字典排序',


        'system.dict-data.dictSort.required': 'dictSort required',
        'system.dict-data.status.label': 'status',
        'system.dict-data.status.holder': 'Enter status',
        'system.dict-data.status.max': 'status max length: 状态',


        'system.dict-data.status.required': 'status required',
        'system.dict-data.remark.label': 'remark',
        'system.dict-data.remark.holder': 'Enter remark',
        'system.dict-data.remark.max': 'remark max length: 备注',


        'system.dict-data.remark.required': 'remark required',
        'system.dict-data.createTime.label': 'createTime',
        'system.dict-data.createTime.holder': 'Enter createTime',
        'system.dict-data.createTime.max': 'createTime max length: 创建时间',


        'system.dict-data.createTime.required': 'createTime required',
        'system.dict-data.updateTime.label': 'updateTime',
        'system.dict-data.updateTime.holder': 'Enter updateTime',
        'system.dict-data.updateTime.max': 'updateTime max length: 更新时间',


        'system.dict-data.updateTime.required': 'updateTime required',
        'system.dict-data.deleted.label': 'deleted',
        'system.dict-data.deleted.holder': 'Enter deleted',
        'system.dict-data.deleted.max': 'deleted max length: 是否删除',


        'system.dict-data.deleted.required': 'deleted required'
    }
}
